import React from 'react';
import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { SidebarEntry, isSection } from './navConfig';
import SidebarItem from './SidebarItem';
import SidebarSection from './SidebarSection';
import SidebarList from './SidebarList';

type Props = {
  readonly entries: ReadonlyArray<SidebarEntry>;
};

const SidebarNav = ({ entries }: Props): JSX.Element => {
  return (
    <NavigationMenu.Root orientation="vertical" aria-label="EcosConnect">
      <NavigationMenu.List
        render={
          <SidebarList>
            {entries.map((entry) =>
              isSection(entry) ? (
                <SidebarSection
                  key={`section-${entry.label}`}
                  label={entry.label}
                  icon={entry.icon}
                  items={entry.items}
                />
              ) : (
                <SidebarItem
                  key={`link-${entry.text}`}
                  href={entry.href}
                  exact={!entry.href}
                  icon={entry.icon}
                  label={entry.text}
                />
              )
            )}
          </SidebarList>
        }
      />
    </NavigationMenu.Root>
  );
};

export default SidebarNav;
